import angularDynamicLocale from "angular-dynamic-locale/dist/tmhDynamicLocale.min.js";
export default "tmh.dynamicLocale";



// WEBPACK FOOTER //
// ./src/ui/app/services/dynamicLocale.js